import { SavedArticle } from 'components/main/saved-articles/interfaces'

export const image = (article: SavedArticle, fallbackImageUrl: string) => {
    let sources = ''
    if (article.image_urls) {
        sources = `
            <source
                data-srcset="${article.image_urls.desktop_webp},
                             ${article.image_urls.desktop_webp_2x} 2x"
                srcset="data:,1w"
                media="(min-width: 1200px)"
                type="image/webp"
            >
            <source
                data-srcset="${article.image_urls.desktop_jpg},
                             ${article.image_urls.desktop_jpg_2x} 2x"
                srcset="data:,1w"
                media="(min-width: 1200px)"
                type="image/jpeg"
            >
            <source
                data-srcset="${article.image_urls.tablet_webp},
                             ${article.image_urls.tablet_webp_2x} 2x"
                srcset="data:,1w"
                media="(min-width: 768px)"
                type="image/webp"
            >
            <source
                data-srcset="${article.image_urls.tablet_jpg},
                             ${article.image_urls.tablet_jpg_2x} 2x"
                srcset="data:,1w"
                media="(min-width: 768px)"
                type="image/jpeg"
            >
            <source
                data-srcset="${article.image_urls.mobile_webp},
                             ${article.image_urls.mobile_webp_2x} 2x"
                srcset="data:,1w"
                media="(max-width: 768px)"
                type="image/webp"
            >
            <source
                data-srcset="${article.image_urls.mobile},
                             ${article.image_urls.mobile_2x} 2x"
                srcset="data:,1w"
                media="(max-width: 768px)"
                type="image/jpeg"
            >
        `
    }
    return `
        <a
            href="/${article.origin_url_path}"
            class='article-card__image-link'
        >
            <picture class='article-card__image'>
                ${sources}
                <img
                    alt="image"
                    class="lazyload"
                    height="174"
                    width="232"
                    loading="lazy"
                    data-src="${fallbackImageUrl}"
                    data-srcset="${fallbackImageUrl}"
                    src="${fallbackImageUrl}"
                    srcset="${fallbackImageUrl}"
                >
            </picture>
        </a>
    `
}
